import * as Highcharts from "highcharts";
import DataTable, {Order} from "datatables.net-bs5";
import {color, number_format, post} from "../util";
import * as Tagify from "@yaireo/tagify";
import crafting from "./crafting";
import craftingCalc from "./crafting-calc";
import items from "./items";
import maps from "./maps";
import npc from "./npc";
import paperdoll from "./paperdoll";
import personal from "./personal";
import { getChartTheme } from "../utils/chartTheme";
declare let users_array : any[];
declare const count_array : string[];
declare const dates_array : string[];
declare const levels_array : any[];
declare const all_users : any[];
declare const interval : number;

export default class {
    static init = () => {
        experience();
        characters();
        status();
        crafting.init();
        craftingCalc.init();
        items.init();
        maps.init();
        npc.init();
        paperdoll.init();
        personal.init();
    }
}

function experience() {
    let chart : Highcharts.Chart;

    if(typeof users_array !== 'undefined') {
        const button_background = getComputedStyle(document.documentElement).getPropertyValue('--ksat-surface-raised').trim();

        let series: Highcharts.SeriesOptionsType[] = [];
        users_array.forEach((user) => {
            let data = interpolateData(user.data);
            //@ts-ignore
            series.push({
                name: user.name,
                data: data,
                visible: true,
                connectNulls: true,
                color: user.color
            });
        });

        let plotLines : Highcharts.YAxisPlotLinesOptions[] = [];
        levels_array.forEach((level) => {
            plotLines.push({
                color: 'grey',
                value: level.exp,
                width: 1,
                dashStyle: 'Dash',
                label: {
                    text: "Level " + level.level,
                    align: 'right',
                    style: {
                        color: 'grey'
                    }
                }
            });
        });

        chart = Highcharts.chart("chart_eo_exp", Highcharts.merge(getChartTheme(), {
            series: series as Highcharts.SeriesOptionsType[],
            chart: {
                type: 'spline',
                height: 800,
                zooming: {
                    type: 'x',
                    resetButton: {
                        position: {
                            align: "right",
                            x: 0,
                            y: -30
                        },
                        theme: {
                            fill: button_background,
                            stroke: "none",
                            style: {
                                backgroundColor: button_background
                            },
                            states: {
                                hover: {
                                    fill: button_background,
                                    style: {
                                        backgroundColor: button_background
                                    }
                                }
                            }
                        }
                    }
                },
            },
            title: {
                text: 'Experience',
                // align: 'left',
                style: {
                    fontSize: '14px'
                }
            },
            legend: {
                enabled: true,
            },
            //@ts-ignore
            xAxis: {
                type: 'datetime',
                labels: {
                    overflow: 'justify',
                }
            },
            // @ts-ignore
            yAxis: {
                title: {
                    text: '',
                },
                plotLines: plotLines,
                minorGridLineWidth: 0,
                gridLineWidth: 0,
                alternateGridColor: null,
            },
            tooltip: {
                valueSuffix: ' exp',
                xDateFormat: '%b %e, %Y %H:%M'
            },
            plotOptions: {
                spline: {
                    lineWidth: 4,
                    states: {
                        hover: {
                            lineWidth: 5
                        }
                    },
                    marker: {
                        enabled: false
                    },
                    pointInterval: interval,
                    pointStart: Date.parse(dates_array[0]) - (1000 * 60 * 60 * 4),
                }
            },
            credits: {
                enabled: false
            }
        } as any) as Highcharts.Chart);

        let users_input = document.querySelector('.js-users') as HTMLInputElement;
        let tags = new Tagify(users_input, {
            whitelist: all_users.map((user) => user.name),
            enforceWhitelist: true,
            dropdown: {
                enabled: 1,
                closeOnSelect: false
            }
        });

        let selected_users: any[] = [];
        users_array.forEach((user) => {
            selected_users.push(user.name);
        });
        tags.addTags(selected_users);

        tags.on('add', (e) => {
            if(chart.series.map((series) => series.name).indexOf(e.detail.data.value) === -1) {
                post('?do=getExperience', {
                    name: e.detail.data.value,
                    date: dates_array[dates_array.length - 1]
                }, (response: any) => {
                    let data = interpolateData(response.data);
                    chart.addSeries({
                        name: e.detail.data.value,
                        data: data,
                        visible: true,
                        connectNulls: true,
                    } as Highcharts.SeriesOptionsType);
                    users_array.push({
                        id: response.id,
                        name: e.detail.data.value,
                        data: data
                    });
                    update_url();
                });
            }
        });

        tags.on('remove', (e) => {
            let series = chart.series.find((series) => series.name === e.detail.data.value);
            if(series) {
                series.remove();
                users_array = users_array.filter((user) => user.name !== e.detail.data.value);
                update_url();
            }
        });

        update_url();

    }

    function update_url() {
        let users = users_array.map((user) => user.id).join('-');
        let url = new URL(window.location.origin+'/eo/exp/'+users);
        window.history.replaceState({}, '', url.toString());
    }
}

function characters() {
    let table = document.querySelector('.datatable[data-table="characters"]') as HTMLElement;
    if(!table) {
        return;
    }

    let datatable = new DataTable('.datatable[data-table="characters"]',{
        pageLength: 20,
        lengthMenu: [10,20,50,100],
        processing: true,
        serverSide: true,
        responsive: true,
        ajax: {
            url: '?do=getCharacters',
            data: function(data) {
                return data;
            }
        },
        columns: [
            { data: null, render: function(data) {
                return `<a href="/eo/exp/${data.id}">${data.name}</a>`;
            }},
            { data: 'gender' },
            { data: 'class' },
            { data: 'level' },
            { data: null, render: (data) => data.exp === null ? '-' : number_format(data.exp,0)},
            { data: null, render: (data) => color(data.exp_gain_hour,data.exp_gain_hour_color,true)},
            { data: null, render: (data) => color(data.exp_gain_day,data.exp_gain_day_color,true)},
            { data: null, render: (data) => color(data.exp_gain_week,data.exp_gain_week_color,true)},
            { data: null, render: (data) => {
                return data.is_online == 0 ? `<span class="badge text-bg-danger">Offline</span>` : `<span class="badge text-bg-success">Online</span>`;
            }},
        ],
        order: [[6,"desc"]] as Order[]
    });
}

function status() {
    if(typeof count_array !== 'undefined') {
        const button_background = getComputedStyle(document.documentElement).getPropertyValue('--ksat-surface-raised').trim();

        let series: Highcharts.SeriesOptionsType[] = [];
        let data = interpolateData(count_array);
        //@ts-ignore
        series.push({
            name: 'Online',
            data: data,
            visible: true,
            connectNulls: true,
            color: 'rgb(40, 167, 69)',
            fillColor: {
                linearGradient: [0, 0, 0, 300],
                stops: [
                    [0, 'rgb(40, 167, 69)'],
                    [1, 'rgba(40, 167, 69, 0)']
                ]
            },
        });

        Highcharts.chart("chart_eo_online", Highcharts.merge(getChartTheme(), {
            series: series as Highcharts.SeriesOptionsType[],
            chart: {
                type: 'areaspline',
                height: 400,
                zooming: {
                    type: 'x',
                    resetButton: {
                        position: {
                            align: "right",
                            x: 0,
                            y: -30
                        },
                        theme: {
                            fill: button_background,
                            stroke: "none",
                            style: {
                                backgroundColor: button_background
                            },
                            states: {
                                hover: {
                                    fill: button_background,
                                    style: {
                                        backgroundColor: button_background
                                    }
                                }
                            }
                        }
                    }
                },
            },
            title: {
                text: 'Player Count',
                // align: 'left',
                style: {
                    fontSize: '14px'
                }
            },
            legend: {
                enabled: true,
            },
            //@ts-ignore
            xAxis: {
                type: 'datetime',
                labels: {
                    overflow: 'justify',
                }
            },
            // @ts-ignore
            yAxis: {
                title: {
                    text: '',
                },
                minorGridLineWidth: 0,
                gridLineWidth: 0,
                alternateGridColor: null,
            },
            tooltip: {
                valueSuffix: ' players',
                xDateFormat: '%b %e, %Y %H:%M'
            },
            plotOptions: {
                areaspline: {
                    lineWidth: 3,
                    states: {
                        hover: {
                            lineWidth: 4
                        }
                    },
                    marker: {
                        enabled: false
                    },
                    pointInterval: interval,
                    pointStart: Date.parse(dates_array[0]) - (1000 * 60 * 60 * 4),
                }
            },
            credits: {
                enabled: false
            }
        } as any));
    }
}

function interpolateData(data: any[]) {
    let interpolatedData = [...data];  // Copy the original data

    for (let i = 0; i < data.length; i++) {
        if (data[i] === null) {
            let prevIndex = i - 1;
            let nextIndex = i + 1;

            // Find the previous non-null value
            while (prevIndex >= 0 && data[prevIndex] === null) {
                prevIndex--;
            }

            // Find the next non-null value
            while (nextIndex < data.length && data[nextIndex] === null) {
                nextIndex++;
            }

            // Only interpolate if there are valid points on both sides
            if (prevIndex >= 0 && nextIndex < data.length) {
                let prevValue = data[prevIndex];
                let nextValue = data[nextIndex];

                let steps = nextIndex - prevIndex;
                let stepValue = (nextValue - prevValue) / steps;

                // Interpolate values for all null points between prevIndex and nextIndex
                for (let j = 1; j < steps; j++) {
                    interpolatedData[prevIndex + j] = Math.floor(prevValue + j * stepValue);
                }
            }
        }
    }

    return interpolatedData;
}
